<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="6">
            <label>栏目名称：</label>
            <a-select
              v-model="querySectionCode"
              placeholder="请选择"
              style="width: 180px"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option
                :value="item.dicCode"
                v-for="item in sectionInfos"
                :key="item.dicCode"
                >{{ item.dicValue }}</a-select-option
              >
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
          <a-button
            type="primary"
            class="query_btn"
            @click="() => addMethod('add')"
          >
            新增
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.sectionCode + record.disciplineCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a
              href="javascript:void(0);"
              @click="
                () => deleteMethod(record.sectionCode, record.disciplineCode)
              "
            >
              删除
            </a>
          </span>
        </a-table>
      </div>
    </div>
    <a-modal
      :title="title"
      v-model="visible"
      width="800px"
      @cancel="cancel"
      @ok="enSure"
      :maskClosable="false"
    >
      <template>
        <div class="modal_content">
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>版本：
            </a-col>
            <a-col :span="12">
              <a-select
                style="width: 100%"
                placeholder="请选择"
                v-model="sectionDiscipline.sectionCode"
              >
                <a-select-option
                  v-for="item in sectionInfos"
                  :value="item.dicCode"
                  :key="item.dicValue"
                  >{{ item.dicValue }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>学科：
            </a-col>
            <a-col :span="12">
              <a-select
                style="width: 100%"
                placeholder="请选择"
                mode="multiple"
                v-model="sectionDiscipline.disciplineCode"
              >
                <a-select-option
                  v-for="item in disciplineInfos"
                  :value="item.dicCode"
                  :key="item.dicValue"
                  >{{ item.dicValue }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="提示"
      v-model="delVisible"
      @ok="deleteOk"
      centered
      :maskClosable="false"
      width="300px"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>
  
  
  <script>
import moment from "moment";
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    width: 80,
    align: "center",
    customRender: (text, record, index) => `${index + 1}`,
  },
  {
    title: "版本",
    dataIndex: "sectionName",
  },
  {
    title: "学科",
    dataIndex: "disciplineName",
  },
  {
    title: "操作",
    key: "action",
    width: 180,
    scopedSlots: { customRender: "operator" },
  },
];

const data = [];
import qs from "qs";
export default {
  name: "conlumn",
  components: {},
  data() {
    return {
      data,
      columns,
      sectionDiscipline: { sectionCode: "", disciplineCode: [] },
      visible: false,
      title: "",
      currentMode: "check",
      delVisible: false,
      querySectionCode: "",
      delSectionCode: "",
      delDisciplineCode: "",
      value: 1,
      table_height: 0,
      sectionInfos: [],
      disciplineInfos: [],
    };
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 235;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;

    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
      .then((res) => {
        if (res.data) {
          this.sectionInfos = res.data;
        } else {
          this.utils.messageInfo(this, "error", "查询刊物版本失败！");
        }
      });
    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "discipline" } })
      .then((res) => {
        if (res.data) {
          this.disciplineInfos = res.data;
        } else {
          this.utils.messageInfo(this, "error", "查询学科失败！");
        }
      });
  },
  methods: {
    moment,
    query() {
      this.axios
        .get("/sectionDisciplineRel/listSectionDisciplineRel", {
          params: {
            sectionCode: this.querySectionCode,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询版本学科列表失败！");
          }
        });
    },
    addMethod(type) {
      this.sectionDiscipline = { sectionCode: "", disciplineCode: [] };
      this.visible = true;
      this.title = "新增";
      this.currentMode = type;
    },
    deleteMethod(sectionCode, disciplineCode) {
      this.delVisible = true;
      this.delSectionCode = sectionCode;
      this.delDisciplineCode = disciplineCode;
    },
    deleteOk() {
      this.axios
        .post("/sectionDisciplineRel/deleteSectionDisciplineRel", {
          sectionCode: this.delSectionCode,
          disciplineCode: this.delDisciplineCode,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    enSure() {
      if (this.sectionDiscipline.sectionCode == "") {
        this.utils.messageInfo(this, "error", "请选择版本");
        return;
      }
      if (this.sectionDiscipline.disciplineCode.length == 0) {
        this.utils.messageInfo(this, "error", "请选择学科");
        return;
      }
      this.axios
        .post("/sectionDisciplineRel/saveSectionDisciplineRel", {
          sectionCode: this.sectionDiscipline.sectionCode,
          disciplineCode: this.sectionDiscipline.disciplineCode.join(),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "添加成功");
            this.query();
            this.visible = false;
          } else {
            this.utils.messageInfo(this, "error", "添加失败！");
          }
        });
    },
  },
};
</script>
  <style>
@import "../../../../assets/css/PageCss.css";
</style>
  <style scoped>
.modal_content .ant-row {
  margin: 10px 0;
}
.modal_content .ant-row .title {
  height: 32px;
  line-height: 32px;
  text-align: right;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
  